import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export function FAQ() {
  const faqs = [{
    q: '¿Cómo recibo el Protocolo después de comprar?',
    a: 'Inmediatamente después del pago recibís un email con el link de descarga. En menos de 5 minutos tenés todos los tomos y bonos en tu dispositivo, listos para usar desde hoy mismo. No necesitás esperar ningún envío físico ni instalación.'
  }, {
    q: '¿Necesito conocimientos previos de neurociencia o psicología?',
    a: 'No. El Protocolo está diseñado para el hombre de 50+ sin formación técnica previa. Cada ejercicio explica qué hace, por qué funciona y cómo ejecutarlo. Sin jerga innecesaria. Sin teoría interminable. Solo práctica.'
  }, {
    q: '¿Cuánto tiempo por día requiere el entrenamiento?',
    a: 'Entre 15 y 30 minutos por día es suficiente para completar el programa con resultados medibles. Los bonos de activación matutina y ritual nocturno agregan 10 minutos más. En total, menos de 45 minutos al día para un cerebro que funcione como hace 15 años.'
  }, {
    q: '¿Puedo hacerlo en tablet o necesito imprimirlo?',
    a: 'Las dos opciones funcionan perfectamente. El material está diseñado para usarse en pantalla o impreso en A4. Muchos usuarios imprimen los ejercicios del día y los hacen con lápiz, que es la forma más efectiva de entrenamiento cognitivo.'
  }, {
    q: '¿Funciona para alguien que ya tiene deterioro cognitivo diagnosticado?',
    a: 'El Protocolo está diseñado para la prevención y el mantenimiento cognitivo en hombres sanos de 50+, no como tratamiento médico. Si hay un diagnóstico clínico de deterioro cognitivo, el material puede ser un complemento pero no reemplaza la atención profesional. Consultá con tu médico.'
  }, {
    q: '¿El Método Blindaje está incluido en las dos opciones?',
    a: 'El Método Blindaje™ es el upsell exclusivo de la Opción 2. La Opción 1 incluye los 4 Tomos y los 4 Bonos. La Opción 2 agrega el Método Blindaje completo: el sistema de respuesta cognitiva para situaciones de crisis, conflicto y alta presión.'
  }, {
    q: '¿Tiene algún costo oculto después de la compra?',
    a: 'No. El pago es único. Sin suscripciones, sin cuotas, sin renovaciones. Pagás una vez y el sistema es tuyo para siempre.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-10 px-4 bg-dark-card/30 pt-[15px] pb-[15px]" data-id="element-139">
      <div className="max-w-2xl mx-auto" data-id="element-140">
        <h2 className="text-2xl md:text-3xl font-black text-center mb-6" data-id="element-141">
          ❓ PREGUNTAS FRECUENTES
        </h2>

        <div className="space-y-2" data-id="element-142">
          {faqs.map((faq, i) => <div key={i} className="bg-dark border border-dark-border rounded-xl overflow-hidden" data-id="element-143">
              <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full flex items-center justify-between p-4 text-left focus:outline-none" data-id="element-144">
                <span className="font-bold text-sm" data-id="element-145">{faq.q}</span>
                <ChevronDown className={`w-4 h-4 text-brand transition-transform duration-300 flex-shrink-0 ml-2 ${openIndex === i ? 'rotate-180' : ''}`} data-id="element-146" />
              </button>
              <AnimatePresence data-id="element-147">
                {openIndex === i && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-148">
                    <div className="px-4 pb-4 text-gray-400 text-sm border-t border-dark-border/50" data-id="element-149">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}